import type { IconDefinition } from '../index.tsx';

export const iconStar: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconStar',
  icon: [
    16,
    16,
    [],
    '',
    'M7.00001 0H9.00001L10.4871 4.57681L15.2994 4.57681L15.9175 6.47892L12.0242 9.30754L13.5113 13.8843L11.8933 15.0599L8.00002 12.2313L4.10677 15.0599L2.48873 13.8843L3.97581 9.30756L0.0825195 6.47893L0.700554 4.57682L5.51292 4.57681L7.00001 0Z',
  ],
};
